import { AnimatedFigcaption } from 'components/animated-figcaption'
import { TextContainer } from 'components/container'
import FlowerImage from './assets/Flower_Marya.png'
//import { Title } from 'components/misc'
import { Caption, Svg, Title } from './styled'

export const FlowerSmall = () => (
  <>
    <Title>Марьямоль</Title>
    <AnimatedFigcaption
      FigCaptionComponent={Caption}
      description={
        <p>
          Национальный символ Коми – цветок марьямоль. Его еще называют марьин
          корень или пион уклоняющийся. Настойка пиона уклоняющегося применяется
          в народной медицине как седативное средство. Именно это цветок
          собирает девушка в известной одноименной{' '}
          <a
            target="_blank"
            href="https://lyricstranslate.com/ru/%D0%BC%D0%B0%D1%80%D1%8A%D1%8F%D0%BC%D0%BE%D0%BB%D1%8C-%D0%BC%D0%B0%D1%80%D1%8C%D1%8F%D0%BC%D0%BE%D0%BB%D1%8C.html"
            rel="noreferrer"
          >
            песне
          </a>
        </p>
      }
    />
    <Svg
      viewBox="0 0 390 753"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        //d="M344 753C533.986 753 688 598.986 688 409C688 219.014 533.986 65 344 65C154.014 65 0 219.014 0 409C0 598.986 154.014 753 344 753ZM351.5 104C356.747 104 361 99.5228 361 94C361 88.4772 356.747 84 351.5 84C346.253 84 342 88.4772 342 94C342 99.5228 346.253 104 351.5 104Z"
        d="M344 753C533.986 753 688 598.986 688 409C688 219.014 533.986 65 344 65C154.014 65 0 219.014 0 409C0 598.986 154.014 753 344 753Z"
        fill="#F0BAC6"
        fillOpacity="0.75"
        transform="translate(-156 0)"
      />
      {/*<text
      fill="#343431"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Articulat CF"
      fontSize="10"
      letterSpacing="0em"
    >
      <tspan x="304.6" y="52.9">
        <a
          target="_blank"
          href="https://lyricstranslate.com/ru/%D0%BC%D0%B0%D1%80%D1%8A%D1%8F%D0%BC%D0%BE%D0%BB%D1%8C-%D0%BC%D0%B0%D1%80%D1%8C%D1%8F%D0%BC%D0%BE%D0%BB%D1%8C.html"
          rel="noreferrer"
        >
          &#x43f;&#x435;&#x441;&#x43d;&#x435;
        </a>
      </tspan>
    </text>
    <text
      fill="#343431"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Articulat CF"
      fontSize="10"
      letterSpacing="0em"
    >
      <tspan x="35.8496" y="10.9">
        &#x41d;&#x430;&#x446;&#x438;&#x43e;&#x43d;&#x430;&#x43b;&#x44c;&#x43d;&#x44b;&#x439;
        &#x441;&#x438;&#x43c;&#x432;&#x43e;&#x43b; &#x41a;&#x43e;&#x43c;&#x438;
        &#x2013; &#x446;&#x432;&#x435;&#x442;&#x43e;&#x43a;
        &#x43c;&#x430;&#x440;&#x44c;&#x44f;&#x43c;&#x43e;&#x43b;&#x44c;.
        &#x415;&#x433;&#x43e; &#x435;&#x449;&#x435;
        &#x43d;&#x430;&#x437;&#x44b;&#x432;&#x430;&#x44e;&#x442;{' '}
      </tspan>
      <tspan x="24.7461" y="24.9">
        &#x43c;&#x430;&#x440;&#x44c;&#x438;&#x43d;
        &#x43a;&#x43e;&#x440;&#x435;&#x43d;&#x44c; &#x438;&#x43b;&#x438;
        &#x43f;&#x438;&#x43e;&#x43d;
        &#x443;&#x43a;&#x43b;&#x43e;&#x43d;&#x44f;&#x44e;&#x449;&#x438;&#x439;&#x441;&#x44f;.
        &#x41d;&#x430;&#x441;&#x442;&#x43e;&#x439;&#x43a;&#x430;
        &#x43f;&#x438;&#x43e;&#x43d;&#x430;
        &#x443;&#x43a;&#x43b;&#x43e;&#x43d;&#x44f;&#x44e;&#x449;&#x435;&#x433;&#x43e;&#x441;&#x44f;{' '}
      </tspan>
      <tspan x="24.3213" y="38.9">
        &#x43f;&#x440;&#x438;&#x43c;&#x435;&#x43d;&#x44f;&#x435;&#x442;&#x441;&#x44f;
        &#x432; &#x43d;&#x430;&#x440;&#x43e;&#x434;&#x43d;&#x43e;&#x439;
        &#x43c;&#x435;&#x434;&#x438;&#x446;&#x438;&#x43d;&#x435;
        &#x43a;&#x430;&#x43a;
        &#x441;&#x435;&#x434;&#x430;&#x442;&#x438;&#x432;&#x43d;&#x43e;&#x435;
        &#x441;&#x440;&#x435;&#x434;&#x441;&#x442;&#x432;&#x43e;.
        &#x418;&#x43c;&#x435;&#x43d;&#x43d;&#x43e; &#x44d;&#x442;&#x43e;{' '}
      </tspan>
      <tspan x="58.5449" y="52.9">
        &#x446;&#x432;&#x435;&#x442;&#x43e;&#x43a;
        &#x441;&#x43e;&#x431;&#x438;&#x440;&#x430;&#x435;&#x442;
        &#x434;&#x435;&#x432;&#x443;&#x448;&#x43a;&#x430; &#x432;
        &#x438;&#x437;&#x432;&#x435;&#x441;&#x442;&#x43d;&#x43e;&#x439;
        &#x43e;&#x434;&#x43d;&#x43e;&#x438;&#x43c;&#x435;&#x43d;&#x43d;&#x43e;&#x439;{' '}
      </tspan>
    </text>*/}
      <text
        fill="#343431"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Articulat CF"
        fontSize="10"
        fontStyle="italic"
        letterSpacing="0em"
      >
        <tspan x="108.508" y="496.9">
          &#x412;&#x438;&#x437;&#x443;&#x432; &#x44e;&#x4e7;
          &#x43f;&#x435;&#x442;&#x4e7; &#x435;&#x43b;&#x44c;,
          &#x43f;&#x435;&#x442;&#x4e7; &#x435;&#x43b;&#x44c;,
          &#x43f;&#x435;&#x442;&#x4e7; &#x435;&#x43b;&#x44c;,&#10;
        </tspan>
        <tspan x="77.7803" y="510.9">
          &#x411;&#x44b;&#x434;&#x43c;&#x4e7;
          &#x441;&#x44d;&#x442;&#x4e7;&#x43d;
          &#x43c;&#x430;&#x440;&#x44a;&#x44f;&#x43c;&#x43e;&#x43b;&#x44c;,
          &#x43c;&#x430;&#x440;&#x44a;&#x44f;&#x43c;&#x43e;&#x43b;&#x44c;,
          &#x43c;&#x430;&#x440;&#x44a;&#x44f;&#x43c;&#x43e;&#x43b;&#x44c;&#x2026;&#x2028;
        </tspan>
        <tspan x="195.5" y="524.9">
          &#x2028;
        </tspan>
        <tspan x="192.57" y="566.9">
          -&#xa0;&#10;
        </tspan>
        <tspan x="130.896" y="580.9">
          &#x41c;&#x430;&#x440;&#x44a;&#x44f;&#x43c;&#x43e;&#x43b;&#x44c;
          &#x434;&#x430;
          &#x43c;&#x430;&#x440;&#x44a;&#x44f;&#x43c;&#x43e;&#x43b;&#x44c;&#x2026;&#10;
        </tspan>
        <tspan x="130.896" y="594.9">
          &#x41c;&#x430;&#x440;&#x44a;&#x44f;&#x43c;&#x43e;&#x43b;&#x44c;
          &#x434;&#x430;
          &#x43c;&#x430;&#x440;&#x44a;&#x44f;&#x43c;&#x43e;&#x43b;&#x44c;&#x2026;&#x2028;
        </tspan>
        <tspan x="195.5" y="608.9">
          &#x2028;
        </tspan>
        <tspan x="192.57" y="650.9">
          -&#xa0;&#10;
        </tspan>
        <tspan x="85.6221" y="664.9">
          &#x421;&#x438;&#x43a;&#x4e7;&#x442;&#x448;
          &#x432;&#x44b;&#x43b;&#x4e7;
          &#x43a;&#x443;&#x438;&#x43c;-&#x43d;&#x451;&#x43b;&#x44c;,
          &#x43a;&#x443;&#x438;&#x43c;-&#x43d;&#x451;&#x43b;&#x44c;,
          &#x43a;&#x443;&#x438;&#x43c;-&#x43d;&#x451;&#x43b;&#x44c;,&#10;
        </tspan>
        <tspan x="75.3828" y="678.9">
          &#x41a;&#x43e;&#x43b;&#x4e7;
          &#x434;&#x437;&#x43e;&#x440;&#x438;&#x434;&#x437;
          &#x43c;&#x430;&#x440;&#x44a;&#x44f;&#x43c;&#x43e;&#x43b;&#x44c;,
          &#x43c;&#x430;&#x440;&#x44a;&#x44f;&#x43c;&#x43e;&#x43b;&#x44c;,
          &#x43c;&#x430;&#x440;&#x44a;&#x44f;&#x43c;&#x43e;&#x43b;&#x44c;&#x2026;&#x2028;
        </tspan>
        <tspan x="195.5" y="692.9">
          &#x2028;
        </tspan>
      </text>
      <text
        fill="#343431"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Articulat CF"
        fontSize="10"
        fontStyle="italic"
        fontWeight="600"
        letterSpacing="0em"
      >
        <tspan x="113.967" y="538.9">
          &#x41d;&#x430; &#x431;&#x44b;&#x441;&#x442;&#x440;&#x443;&#x44e;
          &#x440;&#x435;&#x447;&#x43a;&#x443;
          &#x432;&#x44b;&#x445;&#x43e;&#x434;&#x438;&#x442;
          &#x440;&#x443;&#x447;&#x435;&#x439;&#10;
        </tspan>
        <tspan x="136.037" y="552.9">
          &#x420;&#x430;&#x441;&#x442;&#x435;&#x442; &#x442;&#x430;&#x43c;
          &#x43c;&#x430;&#x440;&#x44c;&#x44f;&#x43c;&#x43e;&#x43b;&#x44c;....&#10;
        </tspan>
        <tspan x="128.439" y="622.9">
          &#x41c;&#x430;&#x440;&#x44c;&#x44f;&#x43c;&#x43e;&#x43b;&#x44c;
          &#x434;&#x430;
          &#x43c;&#x430;&#x440;&#x44c;&#x44f;&#x43c;&#x43e;&#x43b;&#x44c;...&#10;
        </tspan>
        <tspan x="128.439" y="636.9">
          &#x41c;&#x430;&#x440;&#x44c;&#x44f;&#x43c;&#x43e;&#x43b;&#x44c;
          &#x434;&#x430;
          &#x43c;&#x430;&#x440;&#x44c;&#x44f;&#x43c;&#x43e;&#x43b;&#x44c;...&#10;
        </tspan>
        <tspan x="123.718" y="706.9">
          &#x41d;&#x430;&#x434;&#x43e; &#x43d;&#x430;
          &#x431;&#x443;&#x441;&#x44b; &#x43c;&#x43d;&#x435;
          &#x442;&#x440;&#x438;-&#x447;&#x435;&#x442;&#x44b;&#x440;&#x435;&#10;
        </tspan>
        <tspan x="129.514" y="720.9">
          &#x42d;&#x442;&#x438;&#x445;
          &#x446;&#x432;&#x435;&#x442;&#x43a;&#x43e;&#x432;,
          &#x43c;&#x430;&#x440;&#x44c;&#x44f;&#x43c;&#x43e;&#x43b;&#x44c;...&#10;
        </tspan>
      </text>
      <rect
        x="45"
        y="84"
        width="300"
        height="394"
        fill="url(#flower-small-pattern0)"
      />
      <defs>
        <pattern
          id="flower-small-pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <image
            width="3121"
            height="4096"
            xlinkHref={FlowerImage}
            transform="matrix(0.000320638 0 0 0.000244141 -0.000355632 0)"
          />
        </pattern>
      </defs>
    </Svg>
  </>
)
